import React from "react";
import { useTranslation } from "react-i18next";
import StatusModal, { STATUS } from "../../../../../../components/modal/StatusModal";
import { ModalButton } from "../../../../../../components/modal/ModalButtons";

// Shown after a verification email was sent to the new address, with a
// "resend" button for when it did not arrive.
const ModalSuccessChangeEmail = ({
  newEmail,
  handleClose,
  show,
  handleClickButton,
  isLoading = false,
  isSuccessResendEmail = false,
}) => {
  const { t } = useTranslation();

  return (
    <StatusModal
      show={show}
      onClose={handleClose}
      status={STATUS.SUCCESS}
      titleHtml={t("myPage.accountInformation.modalSuccessChangeEmail.title", { email: newEmail })}
      message={
        <>
          <p
            className="tw:!mb-0"
            dangerouslySetInnerHTML={{ __html: t("myPage.accountInformation.modalSuccessChangeEmail.desc.1") }}
          />
          <p
            className="tw:!mb-0 tw:!text-[#8D8D8D]"
            dangerouslySetInnerHTML={{ __html: t("myPage.accountInformation.modalSuccessChangeEmail.desc.2") }}
          />
        </>
      }
    >
      {/* Resend section: same grey box the cancel-booking popups use for details */}
      <div className="tw:!bg-[#f9f9f9] tw:!rounded-[8px] tw:!p-6 tw:w-full">
        <p
          className="tw:!mb-4 tw:!text-[14px] tw:!text-[#282828]"
          dangerouslySetInnerHTML={{ __html: t("myPage.accountInformation.modalSuccessChangeEmail.desc.3") }}
        />
        <ModalButton
          variant="secondary"
          onClick={handleClickButton}
          isLoading={isLoading}
          disabled={isSuccessResendEmail}
        >
          {t("myPage.accountInformation.modalSuccessChangeEmail.button")}
        </ModalButton>
      </div>
    </StatusModal>
  );
};

export default ModalSuccessChangeEmail;
